<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Most traded symbols</b-card-title>
    </b-card-header>
    <b-card-body class="d-flex flex-wrap">
      <b-col cols="12">
        <template v-if="loading">
          <div
            class="d-flex align-items-center w-100 justify-content-between mt-1"
            v-for="i in 5"
            :key="i"
          >
            <b-skeleton class="px-1" width="15%" height="30px" />
            <b-skeleton class="px-1" width="15%" height="30px" />
            <b-skeleton class="" width="60%" height="30px" />
          </div>
        </template>
        <template v-else-if="symbols.length">
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="ps-customizer-area scroll-area"
          >
            <div
              v-for="(item, index) in symbols"
              :key="index"
              class="d-flex align-items-end w-100 py-md-1 py-1 flex-wrap employee-task"
            >
              <div class="col-md-3 col-6 px-0">
                <span>{{ index + 1 }} </span>
                <span class="lineHR"> </span>
                <span class="px-50">{{ item.symbol || "-" }}</span>
              </div>
              <template v-if="!loader">
                <div
                  class="d-flex col-md-2 col-6 px-0"
                  v-if="item.url && Object.keys(item.url).length"
                >
                  <template v-for="(key, index) in Object.keys(item.url)">
                    <div
                      class="d-flex position-relative"
                      v-if="key.includes('logoid')"
                      :key="index"
                    >
                      <b-img
                        :src="convertUrl(item.url[key])"
                        width="25"
                        height="25"
                        class="rounded-50"
                        @error="setAltImg"
                        :alt="item.symbol"
                        :style="[
                          key.includes('base') &&
                            'position:absolute;right: 16px;',
                        ]"
                      />
                    </div>
                  </template>
                </div>
                <div class="d-flex col-md-2 col px-md-0 pr-50 pl-0" v-else>
                  <div class="d-flex">
                    <b-img
                      width="25"
                      height="25"
                      class="rounded-50"
                      :src="errorImage"
                      @error="setAltImg"
                      :alt="item.symbol"
                    />
                  </div>
                  <div class="d-flex position-relative">
                    <b-img
                      width="25"
                      height="25"
                      class="rounded-50"
                      :src="errorImage"
                      @error="setAltImg"
                      :alt="item.symbol"
                      :style="['position:absolute;right: 16px;']"
                    />
                  </div>
                </div>
              </template>
              <div class="d-flex col-md-2 col-6 px-0" v-else>
                <div class="d-flex">
                  <b-img
                    width="25"
                    height="25"
                    class="rounded-50"
                    :src="errorImage"
                    @error="setAltImg"
                    :alt="item.symbol"
                  />
                </div>
                <div class="d-flex position-relative">
                  <b-img
                    width="25"
                    height="25"
                    class="rounded-50"
                    :src="errorImage"
                    @error="setAltImg"
                    :alt="item.symbol"
                    :style="['position:absolute;right: 16px;']"
                  />
                </div>
              </div>
              <div class="col-md-7 col-12 px-0 py-md-0 py-50" v-if="!loader">
                <b-card-text class="mb-0">
                  {{ item.value ? item.value.toFixed(2) : 0 + "%" }}
                </b-card-text>
                <b-progress
                  class="progress-bar-info"
                  v-model="item.value"
                  max="100"
                  height="10px"
                />
              </div>
            </div>
          </vue-perfect-scrollbar>
        </template>
        <template v-else>
          <div
            class="d-flex align-items-center justify-content-center h-100 new-alert"
          >
            <b-alert
              show
              variant="secondary"
              class="d-flex align-items-center justify-content-center p-3 w-100"
            >
              no information
            </b-alert>
          </div>
        </template>
      </b-col>
      <!-- <b-col md="5" cols="12">
        <vue-apex-charts
          type="radar"
          height="100%"
          width="100%"
          :options="radarChart.chartOptions"
          :series="radarChart.series"
        />
      </b-col> -->
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCol,
  BCard,
  BMedia,
  BAvatar,
  BMediaBody,
  BMediaAside,
  BCardBody,
  BCardTitle,
  BCardHeader,
  BProgress,
  BImg,
  BCardText,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
// import VueApexCharts from "vue-apexcharts";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  components: {
    BCol,
    BCard,
    BMedia,
    BAvatar,
    BMediaBody,
    BMediaAside,
    BCardBody,
    BCardTitle,
    BCardHeader,
    // VueApexCharts,
    BProgress,
    BImg,
    BCardText,
    BSkeleton,
    BAlert,
    VuePerfectScrollbar,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      symbols: [],
      total: 0,
      loader: false,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },

  watch: {
    async analytics(val) {
      this.loader = true;
      this.symbols = await val.most_symbol_trades;
      let promiseReq = [];
      await this.symbols.map(async (symbol, index) => {
        if (symbol.symbol) {
          promiseReq.push(this.getSymboles(symbol.symbol, index));
        }
        this.total += symbol.count;
      });
      await Promise.all([...promiseReq]);
      await this.symbols.forEach((symbol) => {
        symbol.value = (100 * symbol.count) / this.total;
      });
      this.loader = false;
    },
  },

  methods: {
    convertUrl(logoId) {
      return `https://s3-symbol-logo.tradingview.com/${logoId}.svg`;
    },
    async getSymboles(symbol, index) {
      try {
        const { data } = await this.$http.get(
          `/panel/symbol-search?text=${symbol.trim()}`
        );
        this.symbols[index].url =
          data.data.symbols && data.data.symbols[0] ? data.data.symbols[0] : {};
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
.ps-customizer-area {
  max-height: 650px;
}

.rounded-50 {
  border-radius: 50%;
  border: 1px solid #1b1b24;
}

.lineHR {
  height: 20px;
  width: 1px;
  background-color: #a3a4ae0d;
  display: inline-block;
  margin: 0 5px -5px 5px;
}
</style>
